import { render, staticRenderFns } from "./MPPaymentDetail.vue?vue&type=template&id=2599a7d0&"
import script from "./MPPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./MPPaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports